var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import authentication from "@irati/auth";
import getDeviceLocale from "@irati/utils/lang/helpers/getDeviceLocale";
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
import intercomScript, { getIntercomKey } from "./script";
var setIdentity = function () {
    var tenant = authentication.userTenant();
    var user = authentication.user();
    var role = user.role;
    if (!window.Intercom) {
        return notLoaded();
    }
    window.Intercom("shutdown");
    window.Intercom("boot", __assign(__assign({}, defaultSentrySettings()), { user_id: user.uuid, email: user.email, name: firstnameLastname(user), role: role, company: {
            company_id: tenant.subdomain,
            name: tenant.public_name,
            settings: tenant.settings,
            tenant_group_id: tenant.groupId,
            user_locale: user.locale || tenant.locale,
            tenant_locale: tenant.locale,
            tenant_uuid: tenant.uuid
        } }));
};
var clearIdentity = function () {
    if (!window.Intercom) {
        return notLoaded();
    }
    window.Intercom("shutdown");
    window.Intercom("boot", __assign({}, defaultSentrySettings()));
};
var setup = function () {
    intercomScript(getIntercomKey());
    window.Intercom("boot", __assign({}, defaultSentrySettings()));
};
var hideLauncher = function () {
    if (window.Intercom) {
        window.Intercom("update", {
            hide_default_launcher: true
        });
    }
};
var showLauncher = function () {
    if (window.Intercom) {
        window.Intercom("update", {
            hide_default_launcher: false
        });
    }
};
var show = function () {
    if (window.Intercom) {
        window.Intercom("show");
    }
};
var prePop = function (message, url) {
    if (window.Intercom) {
        window.Intercom("showNewMessage", message);
        if (url) {
            window.Intercom("update", { Url: url });
        }
    }
};
var shutdown = function () {
    if (!window.Intercom) {
        return notLoaded();
    }
    window.Intercom("shutdown");
};
export default {
    setup: setup,
    setIdentity: setIdentity,
    clearIdentity: clearIdentity,
    hideLauncher: hideLauncher,
    showLauncher: showLauncher,
    show: show,
    shutdown: shutdown,
    prePop: prePop
};
var thrown = false;
function notLoaded() {
    if (!thrown) {
        // only throw once
        thrown = true;
        // As 3rd party script, cannot always guarantee it will load
        console.error("Intercom failed to load");
    }
    return thrown;
}
function defaultSentrySettings() {
    return {
        app_id: getIntercomKey(),
        region: authentication.userLocale(),
        device_locale: getDeviceLocale(),
        language_override: authentication.userLocale()
    };
}
